<div class="review-dialog">

  <div class="ui-g-12 p-zero dialog-header">
    <div class="send-dialog-heading">Send Receipt</div>
    <i class="fal fa-times fa-sm dialog-close" (click)="closeDialog()"></i>
  </div>

  <div class="ui-g-12 p-zero dialog-body">
    <div class="ui-g-12 p-zero">
      <div class="ui-g-7 p-zero left-box">
        <div class="mt-2">
          <p class="mb-1 font-600">Customer*</p>

          <div class="selected-customer flex-start-center">
            <div class="icon-wrapper">
              <i class="fal fa-user m-0"></i>
            </div>

            <div class="customer-wrapper">
              <div class="customer-name">
                {{customer.fullName || customer.displayName}}
              </div>
            </div>
            <div class="globe-icon" (click)="switchLanguage()" *ngIf="companyLocalization">
              {{currentLang?.toUpperCase()}}
              <i class="fa fa-globe fa-globe" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div class="mt-2">
          <p class="mb-1 font-600">Subject*</p>
          <div class="subject">
            <input id="review-subject" type="text" placeholder="Subject" [(ngModel)]="subject" class="font-13">
          </div>
        </div>

        <div class="mt-2">
          <p class="mb-1 font-600">Message*</p>
          <div class="message">
            <textarea name="content" autocomplete="off" autocorrect="off" spellcheck="false" id="" cols="30" rows="6"
              placeholder="Message" class="font-13" [(ngModel)]="content"></textarea>
          </div>
        </div>
      </div>

      <div class="ui-g-5 p-zero right-box">
        <div *ngIf="customer && customer.customerId">
          <div class="contact-btn d-flex">
            <app-outline-icon-btn id="review-btn-email-selected" class="mr-2" label="Email" icon="fal fa-envelope"
              [active]="isEmailSelected" (handleClick)="toggleActiveState('isEmailSelected', $event)">
            </app-outline-icon-btn>

            <app-outline-icon-btn id="review-btn-sms-selected" class="ml-2p" label="SMS" icon="fal fa-mobile"
              [active]="isSMSSelected" (handleClick)="toggleActiveState('isSMSSelected', $event)">
            </app-outline-icon-btn>
          </div>
        </div>

        <div *ngIf="customer && customer.customerId"
          class="notification-contact-box flex-column flex-center-start mt-2 position-relative"
          tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right"
          [pTooltip]="recipientTooltip" [escape]="false">

          <i class="far fa-edit pointer p-2 update-recipient-icon" tooltipPosition="top"
            [ngClass]="{'not-allowed': !isEmailSelected && !isSMSSelected}"
            [pTooltip]="!isEmailSelected && !isSMSSelected? 'Select Email or Phone to add Recipients': ''"
            (click)="openUpdateRecipientDialog()"></i>

          <div class="width-100p flex-start-center font-13">
            <i class="fal fa-bell font-gray-85 contact-icon flex-center-center"></i>
            <span class="font-bold">Notification</span>
          </div>

          <div class="flex-start-center font-12">
            <i class="fal fa-envelope font-gray-85 contact-icon flex-center-center"></i>
            <span *ngIf="recipients?.emails?.length === 1 ">
              {{recipients?.emails[0].value}}
            </span>

            <span *ngIf="recipients?.emails?.length !== 1">
              <span *ngIf="!recipients?.emails?.length">No email</span>
              <span *ngIf="recipients?.emails?.length">{{recipients?.emails?.length}} email addresses</span>
            </span>
          </div>

          <div class="flex-start-center font-12">
            <i class="fal fa-mobile font-gray-85 contact-icon flex-center-center"></i>
            <span *ngIf="recipients?.phones?.length === 1">
              {{recipients?.phones[0].value| mask: '(000) 000-0000'}}
            </span>

            <span *ngIf="recipients?.phones?.length !== 1">
              <span *ngIf="!recipients?.phones?.length">No phone</span>
              <span *ngIf="recipients?.phones?.length">{{recipients?.phones?.length}} mobile numbers</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="float-left p-zero">
      <div id="review-customer-preview" class="customer-preview" (click)="!isLoadingReceiptURL && downloadReceipt()">
        <i *ngIf="isLoadingReceiptURL" class="fal fa-spinner rotate pr-1"></i>
        <i class="fal fa-paperclip"></i>
        <span>&nbsp;&nbsp;receipt</span>
      </div>
    </div>

    <div class="float-right text-right">
      <button [id]="isEmailSelected || isSMSSelected ? 'submit-btn-send-receipt' : 'submit-btn'" class="btn btn-primary btn-submit" style="width: 100px;" (click)="onSubmit()">Send</button>
    </div>
  </div>
</div>